import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import {
  fetchOutgoingOrdersByDate,
  fetchSalesOrders,
  fetchSalesOrderDetail,
} from '../../actions/sales_actions';

import {
  fetchDashboardMessages,
  postDashboardMessage,
  setField,
} from '../../actions/dashboard_actions';
import {
  fetchIncomingOrdersByDate,
  fetchPurchaseOrders,
  fetchPurchaseOrdersNotReceived,
  fetchTotalPurchases,
  resetCurrentPurchaseOrder,
  selectPurchaseOrder,
  fetchPurchaseOrderList,
} from '../../actions/purchaseOrders_actions';
import {
  printPurchaseOrder,
} from '../../actions/print_actions';

import GeneralDashboard from '../../components/General/generalDashboardRevision';

const generalDashboard = reduxForm({
  form: 'generalDashboard',
})(GeneralDashboard);

const selector = formValueSelector('generalDashboard');

function mapStateToProps(state) {
  const poDateChosen = selector(state, 'selectedPODate');
  const soDateChosen = selector(state, 'selectedSODate');
  const Message = selector(state, 'MessageField');
  const Color = selector(state, 'Color');
  const Quote_id = selector(state, 'Quote_id');
  return {
    poDateChosen,
    soDateChosen,
    Message,
    Color,
    Quote_id,
    todaysIncomingOrders: state.purchaseOrders.todaysIncomingOrders,
    todaysIncomingOrdersIsLoading: state.purchaseOrders.todaysIncomingOrdersIsLoading,
    todaysIncomingOrdersError: state.purchaseOrders.todaysIncomingOrdersError,

    todaysOutgoingOrders: state.salesOrders.todaysOutgoingOrders,
    todaysOutgoingOrdersIsLoading: state.salesOrders.todaysOutgoingOrdersIsLoading,
    todaysOutgoingOrdersError: state.salesOrders.todaysOutgoingOrdersError,

    salesOrders: state.salesOrders.all,
    SOIsLoading: state.salesOrders.isLoading,
    SOError: state.salesOrders.error,

    messages: state.dashboard.messages,
    messagesIsLoading: state.dashboard.messagesIsLoading,
    messagesError: state.dashboard.messagesError,
    selectedCompany: state.header.selectedCompany,
    selectedWarehouse: state.header.selectedWarehouse,

    purchaseOrderList: state.purchaseOrders.purchaseOrderList,
    purchaseOrderListIsLoading: state.purchaseOrders.purchaseOrderListIsLoading,
    purchaseOrderListError: state.purchaseOrders.purchaseOrderListError,
    
    requestingPurchaseOrderPdf: state.print.requestingPurchaseOrderPdf,
    purchaseOrderPdf: state.print.purchaseOrderPdf,
  };
}

export default connect(mapStateToProps, {
  fetchDashboardMessages,
  fetchIncomingOrdersByDate,
  fetchOutgoingOrdersByDate,
  fetchPurchaseOrders,
  fetchPurchaseOrdersNotReceived,
  fetchSalesOrders,
  fetchTotalPurchases,
  postDashboardMessage,
  resetCurrentPurchaseOrder,
  selectPurchaseOrder,
  fetchPurchaseOrderList,
  printPurchaseOrder,
  fetchSalesOrderDetail,
  setField,
})(generalDashboard);



// WEBPACK FOOTER //
// ./master/jsx/containers/General/generalDashboardRevision.jsx